module.exports = __webpack_public_path__ + "static/cbn-logo-2-b507c5d3cf32ae4eec15a21756a7e5b5.jpg";